import React, { useEffect } from "react";
import CrrButton from "../../../../components/UI/CrrButton/CrrButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./WelcomeScreen.styles.scss";
import { fetchPreassessmentSections } from "../../../../slices/Admin/preAssessments.slice";
import { useDispatch, useSelector } from "react-redux";
import { isPreAssessmentComplete } from "../../../../helpers/utils";

const WelcomeScreen = ({ handleNext }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { sections } = useSelector((state) => state.preAssessment);

  useEffect(() => {
    if (isPreAssessmentComplete()) {
      //skip preassesment if already complete
      history.push("/admin-dashboard");
    } else {
      sections.length == 0 && dispatch(fetchPreassessmentSections(history));
    }
  }, [sections]);

  const benefits = [
    "Identify gaps in your cybersecurity practices",
    "Prepare you for your assessments",
    "Improve risk management",
  ];

  return (
    <>
      <div>
        <div className="welcome-text">Welcome to CYBRBASE </div>
        <div className="welcome-description">
          To get started, we need to setup your profile so that we can,
        </div>
      </div>
      <div className="points">
        {benefits.map((point, index) => (
          <div>
            <span className="number">{index + 1}</span>
            {point}
          </div>
        ))}
      </div>
      <CrrButton className="pre-assessment-btn" onClick={handleNext}>
        GET STARTED
      </CrrButton>
    </>
  );
};

export default WelcomeScreen;
